import { render } from "./LayerEditor.vue?vue&type=template&id=25a5ff50"
import script from "./LayerEditor.vue?vue&type=script&lang=js"
export * from "./LayerEditor.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__